import { format, subMonths } from "date-fns";

export type DatePresetId = "last3m" | "last6m" | "lastCalendarYear" | "custom";

export type IsoDateRange = { startDate: string; endDate: string };

export function getDatePresetRange(
  preset: Exclude<DatePresetId, "custom">
): IsoDateRange {
  const end = new Date();
  const endDate = format(end, "yyyy-MM-dd");
  if (preset === "last3m") {
    return {
      startDate: format(subMonths(end, 3), "yyyy-MM-dd"),
      endDate,
    };
  }
  if (preset === "last6m") {
    return {
      startDate: format(subMonths(end, 6), "yyyy-MM-dd"),
      endDate,
    };
  }
  const y = end.getFullYear() - 1;
  return {
    startDate: `${y}-01-01`,
    endDate: `${y}-12-31`,
  };
}

export function isValidCustomRange(startDate: string, endDate: string): boolean {
  if (!startDate || !endDate) return false;
  return startDate <= endDate;
}
